/** In-memory CSRF token; session cookie ties requests to server-side req.session.csrfToken. */
let csrfToken = null;

export function getCsrfHeaders() {
  if (!csrfToken) return {};
  return { "x-csrf-token": csrfToken };
}

export function setCsrfToken(token) {
  csrfToken = token || null;
}

/**
 * Fetches CSRF token from API and stores it. Returns true only when a token was received and stored.
 */
export function fetchCsrfToken() {
  const base = process.env.REACT_APP_VIZ_URL;
  if (!base) {
    setCsrfToken(null);
    console.warn("[csrf] REACT_APP_VIZ_URL is not set; CSRF token not loaded");
    return Promise.resolve(false);
  }
  return fetch(`${base}/api/auth/csrf-token`, {
    method: "GET",
    mode: "cors",
    cache: "no-cache",
    credentials: "include",
    headers: {
      "Content-Type": "application/json; charset=utf-8",
    },
  })
    .then((res) => {
      if (!res.ok) {
        setCsrfToken(null);
        console.warn("[csrf] csrf-token request failed:", res.status);
        return null;
      }
      return res.json();
    })
    .then((data) => {
      if (data && typeof data.csrfToken === "string") {
        csrfToken = data.csrfToken;
        return true;
      }
      setCsrfToken(null);
      console.warn("[csrf] csrf-token response missing csrfToken");
      return false;
    })
    .catch((err) => {
      setCsrfToken(null);
      console.warn("[csrf] csrf-token fetch failed:", err);
      return false;
    });
}
